import React from 'react';
import {HashRouter,Route,Switch} from 'react-router-dom' 
import oldmanAccreditZwFirst from "./oldmanAccreditforzw/first"
import oldmanAccreditZw from "./oldmanAccreditforzw/index"
import oldmanAccreditZwDetail from "./oldmanAccreditforzw/detail"

const AppRoutes=()=>(
	<div className="AppRoutes" id="routesIndex">
	<HashRouter>
		<Switch>
		{/* 老年人优待证办理--鄂汇办-政务PC */}
		<Route path="/" exact component={oldmanAccreditZwFirst}></Route>
		<Route path="/oldmanAccreditZw/index" exact component={oldmanAccreditZw}></Route>
		<Route path="/oldmanAccreditZw/detail" exact component={oldmanAccreditZwDetail}></Route>
		</Switch>  
	</HashRouter>    
	</div>
)
export default AppRoutes;